export default "__VITE_ASSET__DYjL$cKI__"